import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, Zap } from "lucide-react";
import { toast } from "sonner";

export default function SetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(null);
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!token) { setError("This invite link is missing its code. Ask your admin to send it again."); return; }
    api.get(`/auth/invite/${encodeURIComponent(token)}`).then(({ data }) => setInfo(data))
      .catch((e) => setError(formatApiError(e.response?.data?.detail)));
  }, [token]);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.post("/auth/set-password", { token, password: pw });
      localStorage.setItem("momento_token", data.access_token);
      window.location.href = "/dashboard";
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); setSaving(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md p-8 bg-card border-border/70" data-testid="set-password-page">
        <div className="w-10 h-10 rounded-lg bg-primary flex items-center justify-center mb-5"><Zap className="w-5 h-5 text-white" /></div>
        {error ? <p className="text-sm text-destructive" data-testid="set-password-error">{error}</p> : !info ? <Loader2 className="w-5 h-5 animate-spin text-primary" /> : (
          <div className="space-y-4">
            <div>
              <h1 className="text-2xl font-display font-bold">Welcome, {info.name}</h1>
              <p className="text-sm text-muted-foreground mt-1">Choose a password for <span className="font-mono">{info.email}</span></p>
            </div>
            <div className="space-y-1.5"><Label>Password (min 8)</Label><Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="set-password-input" /></div>
            <div className="space-y-1.5"><Label>Confirm password</Label><Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="set-password-confirm-input" /></div>
            <Button className="w-full" onClick={save} disabled={saving || pw.length < 8 || pw !== confirm} data-testid="set-password-submit">Set password & sign in</Button>
          </div>
        )}
      </Card>
    </div>
  );
}
